import { render, staticRenderFns } from "./RulesInput.vue?vue&type=template&id=221c03f6&"
import script from "./RulesInput.vue?vue&type=script&lang=js&"
export * from "./RulesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports